export default "__VITE_ASSET__dotJKLfs__"